import React from 'react';
import './Input.css'

const Input = (props) => {
    const warningList = props.warnings && props.warnings.map(warning => (
      <p key={warning} className="warning">{warning}</p>
    ));

    return (
        <div className="Input">
            <h3>{props.original}</h3>
            {warningList}
            {
                props.original.length > 50 ?
                    <textarea name={props.name} dir="auto" placeholder={props.placeholder}
                              onChange={props.onChange} defaultValue={props.value} /> :
                    <input type="text" name={props.name} placeholder={props.placeholder} dir="auto" value={props.value}
                           onChange={props.onChange}/>
            }
        </div>
    )
};
export default Input;